export const  scriptConversao = () => {
    const script = document.createElement('script')
    script.innerHTML  = 'scriptUnbounce()'
    document.querySelector('body')?.appendChild(script)
}